import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { ChangeEvent, useState } from "react";
import { ReprocessType } from "generated/graphql";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { reintakeDocument } from "redux/slices/case";

export interface ReprocessIntakeDialogProps {
  open: boolean;
  close: () => void;
  intakeId: number;
}

const ReprocessIntakeDialog = (props: ReprocessIntakeDialogProps) => {
  const { open, close, intakeId } = props;
  const snackpatch = useAppDispatchWithSnackbar();

  const [priorityValue, setPriorityValue] = useState<boolean>(false);
  const handlePriorityValueChange = (event: ChangeEvent<HTMLInputElement>) => setPriorityValue(event.target.checked);

  const [reprocessType, setReprocessType] = useState<ReprocessType>(ReprocessType.ReIntake);
  const handleReprocessTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setReprocessType(event.target.value as ReprocessType);
  };

  const [rebuildPDF, setRebuildPDF] = useState<boolean>(false);
  const handleRebuildPDFChange = (event: ChangeEvent<HTMLInputElement>) => setRebuildPDF(event.target.checked);

  const [loading, setLoading] = useState(false);

  const handleDocumentReintake = () => {
    setLoading(true);
    snackpatch(
      reintakeDocument({
        reprocessType: reprocessType,
        priority: priorityValue,
        intakeId: intakeId,
        rebuildPDF: rebuildPDF,
      }),
      {
        successMessage: "Reprocess request successful",
        errorMessage: "Unable to reprocess document. Please try again later.",
      }
    )
      .then(() => {
        setLoading(false);
        close();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>Reprocess (Will remove all references)</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: 16 }}>Choose how to reprocess your document</DialogContentText>
        <RadioGroup
          aria-label="reprocess stage"
          name="reprocessstage"
          value={reprocessType}
          onChange={handleReprocessTypeChange}>
          <FormControlLabel value={ReprocessType.ReIntake} control={<Radio />} label="Intake" />
          <FormControlLabel value={ReprocessType.ReExtract} control={<Radio />} label="Extraction" />
          <FormControlLabel value={ReprocessType.ReWits} control={<Radio />} label="Entity Detection" />
          <FormControlLabel value={ReprocessType.ReIndex} control={<Radio />} label="Index" />
        </RadioGroup>
        <FormControlLabel
          style={{ display: "block" }}
          control={<Checkbox checked={priorityValue} onChange={handlePriorityValueChange} name="priority" />}
          label="Run with priority"
        />
        <FormControlLabel
          style={{ display: "block" }}
          control={<Checkbox checked={rebuildPDF} onChange={handleRebuildPDFChange} name="rebuild_pdf" />}
          label="Rebuild PDF"
        />
      </DialogContent>
      <DialogActions>
        <Button color="default" onClick={close}>
          Cancel
        </Button>
        <Button color="default" variant="contained" onClick={handleDocumentReintake} disabled={loading}>
          Reprocess
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReprocessIntakeDialog;
